module.exports = __webpack_public_path__ + "img/pic_4.0df13ff5.png";